<template>
    <p
        class="inline-block text-lg leading-5 text-white px-4 py-2 rounded"
        :class="colorClasses"
    >
      <slot/>
    </p>
</template>

<script>
export default {
    name: "Pill",
    props: {
        type: {
            type: String,
            required: true,
        }
    },
    computed: {
        colorClasses() {
            switch (this.type) {
                case 'success':
                    return 'bg-green-900';
                case 'warning':
                    return 'bg-orange-900';
                case 'danger':
                    return 'bg-red-900';
                default:
                    return 'text-black bg-gray-100';
            }
        },
    },
}
</script>

<style scoped>

</style>
